import React from 'react';
import {
  Page,
  Text,
  View,
  StyleSheet,
} from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';

const styles = StyleSheet.create({
 
});

const Form15A = ({result}) => (
  <View size="A4" style={style.page}>
    {/* Header */}
    <View>
    <Text style={[style.subtitle]} >
       Pension Scheme for the Teaching staff in Non Government Secondary School
        ( vide G.R.E. & S.W.D.NO. SSN3365-G, dated 4th November 1968 )
      </Text>
      <Text style={[style.title, style.ArialBlack]} >
       FORMAL APPLICATION FOR PENSION-FORM No. 15-A
      </Text>
    </View>

    <View style={style.solidLine}/>




    {/* From */}
    <View style={[style.paragraph, {marginTop: 20}]}>
      <Text >From:</Text>
      <Text >{result.employeeName}, {result.designation}, {result.institutionName}</Text>
    </View>

    {/* To */}
     <View style={[style.paragraph, {marginTop: 10}]}>
      <Text >To:</Text>
      <Text >Accountant General(A&E)-I , Maharashtra,</Text>
      <Text >Maharshi Karve Road, Mumbai- 20</Text>
    </View>

    {/* Subject */}
       <View style={[style.paragraph, {marginTop: 10}]}>
      <Text>Subject : Application for sanction of Pension</Text>
    </View>

    {/* Body */}
    <View style={style.paragraph}>
      <Text >Sir,</Text>
      <Text>
I beg to say that I am due to retire from service with effect from {result.dateOfRetirement} my date of birth being {result.dateOfBirth}. I therefore, request that steps may kindly be taken with a view to the pension and gratuity admissible to me being sanctioned by the date of my retirement. I desire to draw my pension from {result.treasury} Treasury
      </Text>
    </View>

    <View style={style.paragraph}>
      <Text>
      2.  I hereby declare that I have neither applied or not received any pension or gratuity in respect of any portion of the service qualifying for this pension and / or gratuity is claimed herein not I shall submit an application thereafter without quoting a reference to this application and the orders which may be passed hereon.
      </Text>
    </View>

      <View style={style.paragraph}>
      <Text>
     3. I enclose herewith -
        1)
        Six specimen signature of main duly attested.
        2)
        A passport size photograph also duly attested.
        3)
        Two slips each bearing my left hand thumb and finger impressions.
    </Text>
    </View>

  <View style={style.paragraph}>
      <Text>
        4. My present address is {result.address}
        and address after retirement will be {result.address}
      </Text>
    </View>

    <View style={style.paragraph}>
      <Text>
       5. Nomination for payment of death-cum-retirement gratuity of family Pension has already been filed or is enclosed.
      </Text>
    </View>

    <View style={style.paragraph}>
      <Text>
      6(a) I hereby consent that any overpayments found or money remaining outstanding against me on account of pay, leave salary allowances, loans, house rent etc. may be recovered from my pension and / or gratuity.
      </Text>
    </View>


    {/* Closing */}
<View style={[style.paragraph, { marginTop: 20, flexDirection: 'row', justifyContent: 'space-between' }]}>
  {/* Left side: Date & Place */}
  <View style={{ width: '45%' }}>
    <Text>Date: {result.date}</Text>
    <Text style={{ marginTop: 5 }}>Place: {result.placeOfRetirement}</Text>
  </View>

  {/* Right side: Name & Designation */}
  <View style={{ width: '45%',marginRight: 10, textAlign: 'right' }}>
    <Text>{result.employeeName}</Text>
    <Text style={{ marginTop: 5 }}>{result.designation}</Text>
  </View>
</View>



    {/* Routing */}
    <View style={[style.paragraph, {marginTop: 20}]}>
      <Text>This is not necessary in the case of a gazetted officer.</Text>
      <Text>(3)This is required only in the case of persons who are illiterate and cannot sign their names.</Text>
       <Text style={[{marginLeft: 5}]}>(a)If the pensioner is not willing. He may delete it.</Text>
    </View>
    <Text>Note :- any subsequent change of address should be notified to the head office.</Text>
  </View>
);

export default Form15A;
